/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*Styles*/
import useStyles from '../../styles';

/*Table Components*/
import PositionReconTable from './Components/PositionReconTable';

export default function PositionRecon(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Position Reconciliation
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <Typography color="primary">Position Reconciliation</Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <PositionReconTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
